import React from "react";

import {
    Typography,
    Grid,
    makeStyles,
} from "@material-ui/core";
import CheckBox from "@material-ui/core/Checkbox";
// import CheckBoxIcon from "@material-ui/icons/CheckBox";
// import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import VolumeOn from "@material-ui/icons/VolumeUp";
import VolumeOff from "@material-ui/icons/VolumeOff";
import Switch from "@material-ui/core/Switch";


import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";

import { SoundContext } from "../../viewmodel/providers/sound-context";
import { SoundEffectContext } from "../../viewmodel/providers/soundEffect-context";

const useStyles = makeStyles(() => ({
    fullHeight: {
        height: "100%",
    },
    switchIcon: {
        ["@media (min-width: 780px)"]: {
            transform: "scale(2)",
        },
    },
    volumeIcon: {
        transform: "scale(1.5)",
        ["@media (min-width: 780px)"]: {
            transform: "scale(2.5)",
        },
    },
}));


export default function Settings(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();

    const getValue = () => {
        // console.log("Function to use as backend");
    };

    const { sound, setSound } = React.useContext(SoundContext);
    const { soundEffect, setSoundEffect } = React.useContext(SoundEffectContext);

    const saveSoundEffect = (soundEffect: boolean): void => {
        setSoundEffect(soundEffect);
        if (localStorage.getItem("username")) // just to check if the remeberMe option was used at some point
            localStorage.setItem("soundEffect", soundEffect.toString());
        else
            sessionStorage.setItem("soundEffect", soundEffect.toString());
    };

    const saveSound = (sound: boolean): void => {
        setSound(sound);
        if (localStorage.getItem("username")) // just to check if the remeberMe option was used at some point
            localStorage.setItem("sound", sound.toString());
        else
            sessionStorage.setItem("sound", sound.toString());
    };

    return (
        <MainScreen lower={false} back={true}>
            <Grid container direction="column" justify="space-evenly" classes={{ root: classes.fullHeight }}>
                <Grid container direction="row" justify="space-between">
                    <Typography variant="h4">
                        {t("settings.sound")}
                    </Typography>
                    <CheckBox
                        color="primary"
                        icon={<VolumeOn />}
                        checked={!soundEffect}
                        checkedIcon={<VolumeOff />} onChange={() => saveSoundEffect(!soundEffect)}
                        className={`${classes.volumeIcon}`}
                    />
                </Grid>
                <Grid container direction="row" justify="space-between">
                    <Typography variant="h4">
                        {t("settings.music")}
                    </Typography>
                    <CheckBox
                        color="primary"
                        icon={<VolumeOn />}
                        checked={!sound}
                        checkedIcon={<VolumeOff />} onClick={() => saveSound(!sound)}
                        classes={{ root: classes.volumeIcon }}
                    />
                </Grid>
                <Grid container direction="row" justify="space-between">
                    <Typography variant="h4">
                        {t("settings.public")}
                    </Typography>
                    <Switch
                        color="primary"
                        onChange={() => getValue()}
                        classes={{ root: classes.switchIcon }}
                    />
                </Grid>
                <Grid container direction="row" justify="space-between" wrap="nowrap" alignItems="center">
                    <Typography variant="h4">
                        {t("settings.friends-only")}
                    </Typography>
                    <Switch
                        color="primary"
                        onChange={() => getValue()}
                        classes={{ root: classes.switchIcon }}
                    />
                </Grid>
            </Grid>
        </MainScreen>
    );
}
